import SeoHead, { localBusinessJsonLd } from "@/components/SeoHead";
import ServicesGrid from "@/components/ServicesGrid";
import CtaBanner from "@/components/CtaBanner";
import CitiesGrid from "@/components/CitiesGrid";
import QuoteForm from "@/components/QuoteForm";

export default function ServicesIndex() {
  return (
    <>
      <SeoHead
        title="Services de Dégraissage & Nettoyage de Hotte - Dégraissage Hotte Melun"
        description="Découvrez nos 10 services experts : dégraissage hotte restaurant, nettoyage extraction cuisine, gaines de ventilation, VMC restaurant, entretien et plus."
        canonicalPath="/services"
        jsonLd={localBusinessJsonLd()}
      />
      <section className="relative bg-white">
        <div className="absolute inset-0 dh-radial-glow pointer-events-none" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 md:pt-24 pb-10">
          <div className="text-sm uppercase tracking-[0.25em] text-[#066ec4] font-bold mb-4">Nos services</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-[#00367e] leading-[1.05]">
            10 services experts pour <span className="dh-underline">votre cuisine pro</span>
          </h1>
          <p className="mt-6 max-w-3xl text-lg text-slate-700">
            Dégraissage, nettoyage, entretien, attestation : nous prenons en charge l'intégralité du nettoyage technique de vos installations CHR en Seine-et-Marne.
          </p>
        </div>
      </section>
      <ServicesGrid title={<>Tous nos services</>} />
      <CtaBanner />
      <CitiesGrid />
      <QuoteForm />
    </>
  );
}
